// 价格同步限速表单的草稿与换算（D218，docs/04 第 13 节）。
import type { PriceSyncRate, PriceSyncSetting } from "@/app/priceTimeline";
import type { Errors } from "@/app/useDraft";

export interface PriceSyncRateDraft { min_gap_ms: string; duty_percent: string }

export function priceSyncRateDraft(s: PriceSyncRate): PriceSyncRateDraft {
  return { min_gap_ms: String(s.min_gap_ms), duty_percent: String(s.duty_percent) };
}

function intIn(v: string, min: number, max: number): number | null {
  const n = /^\d+$/.test(v.trim()) ? Number(v) : NaN;
  return n >= min && n <= max ? n : null;
}

/** 校验并换算：最小间隔 0 到 60000 毫秒，占空比 1 到 100。 */
export function priceSyncRateInput(d: PriceSyncRateDraft): { body?: PriceSyncRate; errors: Errors<PriceSyncRateDraft> } {
  const gap = intIn(d.min_gap_ms, 0, 60000);
  const duty = intIn(d.duty_percent, 1, 100);
  const errors: Errors<PriceSyncRateDraft> = {};
  if (gap === null) errors.min_gap_ms = "0 到 60000 的整数。";
  if (duty === null) errors.duty_percent = "1 到 100 的整数。";
  if (gap === null || duty === null) return { errors };
  return { errors, body: { min_gap_ms: gap, duty_percent: duty } };
}

/** 页面上的一句话摘要；默认值即不限速。 */
export function rateSummary(s: Pick<PriceSyncSetting, "min_gap_ms" | "duty_percent">): string {
  const unlimited = s.min_gap_ms === 0 && s.duty_percent === 100;
  return `限速：最小间隔 ${s.min_gap_ms} ms，占空比 ${s.duty_percent}%${unlimited ? "（不限速）" : ""}`;
}
